var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { BouncingArrow } from "../generic/common/BouncingArrow";
import { ButtonHudNormal } from "../generic/common/ButtonHudNormal";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { ArrowAnimationName } from "../tutorial/TutorialConfig";
var ContextMenuButtonsDOM = /** @class */ (function (_super) {
    __extends(ContextMenuButtonsDOM, _super);
    function ContextMenuButtonsDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getContextMenuBouncingArrow = function () {
            var showBouncingArrow = _this.props.showBouncingArrow;
            if (!showBouncingArrow) {
                return;
            }
            var arrowStyle = {
                animationName: ArrowAnimationName.ANIMATE_RIGHT,
                right: "30px",
                top: "-10px",
            };
            return (React.createElement(BouncingArrow, { icon: IdIcon.RedArrowIcn, iconStyle: IdStyles.IconExtraLarge, containerCSSProps: arrowStyle }));
        };
        return _this;
    }
    ContextMenuButtonsDOM.prototype.render = function () {
        var _a = this.props, building = _a.building, canUpgrade = _a.canUpgrade, canMove = _a.canMove, hasDiscount = _a.hasDiscount, onUpgradeClick = _a.onUpgradeClick, onMoveClick = _a.onMoveClick, showBouncingArrow = _a.showBouncingArrow;
        var ContextMenuBouncingArrow = this.getContextMenuBouncingArrow();
        var updgradeTooltipLoca = canUpgrade ? IdLoca.upgrade : IdLoca.tooltip_upgradeMax_web;
        // TODO: implement when loca is ready.
        var moveTooltipLoca = IdLoca.tooltip_move_web;
        var discountAlert = hasDiscount && (React.createElement(Badge, { position: IdBadgePosition.TopRight },
            React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: IdIcon.QuestUpdateIcn })));
        return (React.createElement("div", { className: "flex flex--spaced flex--aligned context-menu-buttons-container" },
            React.createElement(TooltipText, { id: updgradeTooltipLoca, anchor: IdTooltipAnchor.Bottom },
                React.createElement("div", { style: { position: "relative" } },
                    React.createElement(ButtonHudNormal, { onClick: function () { return onUpgradeClick(building); }, disabled: !canUpgrade },
                        discountAlert,
                        React.createElement(Icon, { icon: IdIcon.UpgradeIcn, styleId: IdStyles.IconMedium })))),
            React.createElement(TooltipText, { id: moveTooltipLoca, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonHudNormal, { onClick: function () { return onMoveClick(building); }, disabled: !canMove, soundId: IdEventSoundCore.None },
                    React.createElement(Icon, { icon: IdIcon.MoveIcn, styleId: IdStyles.IconMedium }))),
            showBouncingArrow && ContextMenuBouncingArrow));
    };
    return ContextMenuButtonsDOM;
}(React.PureComponent));
export { ContextMenuButtonsDOM };



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuButtonsDOM.tsx
// module id = 2247
// module chunks = 3